import { createContext, useContext } from 'react';
import { useAgentsList } from '../hooks';

const AgentsContext = createContext(null);

export const AgentsProvider = ({ children }) => {
  const value = useAgentsList();
  return <AgentsContext.Provider value={value}>{children}</AgentsContext.Provider>;
};

export const useAgents = () => {
  const ctx = useContext(AgentsContext);
  if (!ctx) throw new Error('useAgents must be used inside AgentsProvider');
  return ctx;
};
